import React, { useState, useCallback, useEffect } from 'react';

import Header from 'components/AppBar';
import GroupedList from 'components/GroupedList';
import GroupedItem from 'components/GroupedList/components/GroupedItem';
import ModalHeader from 'components/ModalHeader';
import { Desktop, Mobile } from 'components/Responsive';
import Search from 'components/Search';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { GroupedListModel } from 'models/groupedList';
import { htmlT } from 'utils/generic';

import { Container, GroupContainer, ListContainer, Content, List } from './style';

interface Props {
  showList: boolean;
  list: GroupedListModel[];
  onBack: () => void;
  onSelect: (selectedModel: GroupedListModel) => void;
}

const GroupedLoyaltyList = ({ showList, list, onSelect, onBack }: Props) => {
  const { t } = useStoreTranslation();
  const [resultSearchList, setResultSearchList] = useState<GroupedListModel[]>([]);
  const [isSearch, setIsSearch] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const searchResultsText = htmlT(t, 'group.groupAggregation.searchResults', { count: resultSearchList?.length });

  useEffect(() => {
    setResultSearchList(list);
    setSearchValue('');
  }, [list]);

  const handleOnSearch = useCallback(
    (value: string) => {
      if (value) {
        setResultSearchList(
          list.filter((item: GroupedListModel) => {
            if (item.name && item.name.toLowerCase().includes(value.toLowerCase())) return true;
            if (item.detail && item.detail.toLowerCase().includes(value.toLowerCase())) return true;
            return false;
          }),
        );
        setIsSearch(true);
      } else {
        setResultSearchList([]);
        setIsSearch(false);
      }
    },
    [list],
  );

  const handleSelection = useCallback(
    (selectedValue: GroupedListModel) => {
      onSelect(selectedValue);
    },
    [onSelect],
  );

  if (!showList) return null;

  return (
    <Container>
      <Mobile>
        <Header goBack={onBack}>{t('travelerLoyalty.titleList')}</Header>
      </Mobile>

      <Desktop>
        <ModalHeader title={t('travelerLoyalty.titleList')} onClose={onBack} />
      </Desktop>

      <GroupContainer>
        <Content>
          <ListContainer>
            <Search initialValue={searchValue} hasClose={false} onSearch={handleOnSearch} fullWidth />
            {isSearch ? (
              <List>
                <GroupedItem
                  quantityText={searchResultsText}
                  isSearch={isSearch}
                  items={resultSearchList}
                  onSelection={handleSelection}
                />
              </List>
            ) : (
              <>
                <GroupedList isAlphabetic isSelectable items={list} isSearch={isSearch} onSelection={handleSelection} />
              </>
            )}
          </ListContainer>
        </Content>
      </GroupContainer>
    </Container>
  );
};

export default GroupedLoyaltyList;
